import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CommandController } from '../../../core/component/base/command-controller.base';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { Command, CommandBase, standardCommand } from '../../../core/model/command';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { RentPeriod } from '../../model/rent-period';
import { LeaseAgreementService } from '../../service/data/lease-agreement.service';

@Component({
    selector: 'app-lease-agreement-rent-period-manager',
    templateUrl: './lease-agreement-rent-period-manager.component.html',
    styleUrls: ['./lease-agreement-rent-period-manager.component.scss'],
    providers: [NavigationService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LeaseAgreementRentPeriodManagerComponent extends CommandController implements OnInit {
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _dataService: LeaseAgreementService,
    private _nativeWindow: NativeWindowService,
    private _navigation: NavigationService,
    cdf: ColumnDefinitionFactory,
    commandHandlerResolver: StandardCommandHandlerResolver,
    dispatcher: CommandDispatcher
  ) {
    super(dispatcher, commandHandlerResolver);

    this.columnDefinitions = [
      cdf.createDate('DUE_PERIODS.YEARLY_DUE_DATE_DAY', 'dueDate'),
      cdf.createDate('DUE_PERIODS.INVOICE_PERIOD_FROM', 'fromDate'),
      cdf.createDate('DUE_PERIODS.INVOICE_PERIOD_TO', 'toDate'),
      cdf.createMoney('LEASE_AGREEMENT.RENT_PERIOD_AMOUNT', 'rentIncludingVat'),
      cdf.createMoney('DUE_PERIODS.INVOICED_PERIOD_AMOUNT', 'invoiceTotalAmount'),
      cdf.create('INVOICE.INVOICE_NUMBER', 'invoiceNumber'),
    ];

    this.contextMenuDefinitions = [
      new MenuItemDefinition('LEASE_AGREEMENT.COMMAND.SHOW_INVOICE', standardCommand.edit),
      //new MenuItemDefinition('LEASE_AGREEMENT.COMMAND.CREATE_INVOICE', 'createinvoice')
    ];
  }

  columnDefinitions: ColumnDefinition[];
  rentPeriods: RentPeriod[];
  contextMenuDefinitions: MenuItemDefinition[];

  canExecute(command: CommandBase): boolean {
    switch (command.id) {
      case standardCommand.edit:
      case 'createinvoice':
        return command instanceof Command && command.context;

      default:
        return super.canExecute(command);
    }
  }

  execute(command: CommandBase): void {
    if (command instanceof Command) {
      switch (command.id) {
        case standardCommand.edit:
          this.onRowClicked({ context: command.context, event: {} });
          break;

        case 'createinvoice':
          //  this.AddSubscription(this._dataService.download((<Command>command).context).subscribe(res => {
          //    this._nativeWindow.save(res);
          //  }));
          break;
      }
    }
  }

  ngOnInit() {
    this.AddSubscription(
      this._activatedRoute.paramMap
        .pipe(
          switchMap(map => {
            let id = map.get('leaseAgreementId');
            if (id) {
              return this._dataService.getRentPeriods(id);
            }
            return of([]);
          })
        )
        .subscribe(res => (this.rentPeriods = res))
    );
  }

  onRowClicked(e: { context: any; event: any }) {
    if (e.context.invoiceId !== '') {
      this._navigation.navigate(['invoices', 'edit', e.context.invoiceId]);
    }
  }
}
